import _ from 'lodash';

export const getAllowedTemplates = (allowedTemplateTypes = [], allowedModules = {}) =>
  _.mapValues(allowedModules, (set) => new Set(_.intersection([...set], allowedTemplateTypes)));
